<script setup lang="ts">
import { useI18n } from 'petite-vue-i18n';
import { TEXT } from '../../configs/text';
import { useClassStore } from '../../stores';
import { utils } from '../../utils';
import Heading from '../General/Heading.vue';
import LeaderboardItem from './LeaderboardItem.vue';
import { ClassViewType } from '../../types/class';

const classStore = useClassStore()

const { t } = useI18n()
</script>

<template>
    <Heading>{{ t(TEXT.group_ranking) }}</Heading>
    <div class="w-full overflow-auto pe-1">
        <LeaderboardItem v-if="!classStore.rankedGroups.length" />
        <template v-else>
            <LeaderboardItem v-for="group in classStore.rankedGroups" :key="group.id" :id="group.id"
                :type="ClassViewType.group" :rank="group.rank" :name="group.name"
                :point="utils.calculateGroupTotalPoint(group)" />
        </template>
    </div>
</template>